import { useMutation } from "@shared/lib/hooks";
import { BriefService } from "../services/brief.service";
import { IEditBriefLedger } from "@shared/lib/types/briefLedger";
import { ToastService } from "@shared/lib/services";
import {
  BRIEF_LEDGER_AGGREGATION_QUERY_KEY,
  BRIEF_LEDGER_FACETS_QUERY_KEY,
  BRIEF_LEDGER_QUERY_KEY,
  BRIEF_TOTAL_AGGREGATION_QUERY_KEY,
} from "../constants";

export function useEditBriefLedger() {
  const {
    mutate: edit,
    isLoading: isEditing,
    isSuccess: isEdited,
  } = useMutation({
    mutationFn: (data: IEditBriefLedger) =>
      BriefService.editBriefLedger(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      ToastService.success("Brief ledger updated successfully");
      c.invalidateQueries({ queryKey: BRIEF_LEDGER_QUERY_KEY });
      c.invalidateQueries({ queryKey: BRIEF_LEDGER_FACETS_QUERY_KEY });
      c.invalidateQueries({ queryKey: BRIEF_LEDGER_AGGREGATION_QUERY_KEY });
      c.invalidateQueries({ queryKey: BRIEF_TOTAL_AGGREGATION_QUERY_KEY });
    },
  });

  return {
    edit,
    isEditing,
    isEdited,
  };
}
